import '@appmax_npm/appmax-flashlight'
import { getBaseURL } from './buildBaseURL'

const sendToFlashlight = async (data) => {
  let baseURL = getBaseURL()
  if (baseURL.endsWith('/')) {
    baseURL = baseURL.slice(0, -1)
  }
  const endpoint = `${baseURL}/api/v1/step/flashlight`
  const flashlightEnabled = process.env.VUE_APP_FLASHLIGHT_ENABLED.replace(/"/g, '')

  if (flashlightEnabled) {
    try {
      await window.appmaxFlashlight.send(endpoint, data)
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error sending data to flashlight:', error)
    }
  }
}

export default sendToFlashlight
